import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import theme from '@theme';
import { debounce } from '@utils';
import { StickSentinel } from './components';
import { Provider as StickyProvider } from './StickyContext';
import './styles/index.module.scss';

export const Sticky = ({ children }) => {
  const [isSentinelDisplayed, displaySentinel] = useState(false);
  const [isSticky, setStickiness] = useState(false);

  const fragmentContainer = useRef();

  const stickUpdateHandler = useCallback(status => {
    setStickiness(status);
  }, []);

  useEffect(() => {
    if (fragmentContainer.current)
      fragmentContainer.current.classList.toggle('sticky', isSticky);
  }, [isSticky]);

  useEffect(() => {
    fragmentContainer.current = document.getElementById('fragment-header');

    const onResize = () => {
      const isMobile = window.matchMedia(`(max-width: ${theme.screen.md})`)
        .matches;
      if (isMobile) displaySentinel(true);
      else {
        stickUpdateHandler(false);
        displaySentinel(false);
      }
    };
    const debouncedResizeHandler = debounce(onResize, 100);

    window.addEventListener('resize', debouncedResizeHandler);
    onResize();

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <StickyProvider
      value={{
        isSticky,
      }}
    >
      {children}
      {isSentinelDisplayed && (
        <StickSentinel
          onStickinessUpdate={stickUpdateHandler}
          isSticky={isSticky}
        />
      )}
    </StickyProvider>
  );
};

Sticky.propTypes = {
  children: PropTypes.node.isRequired,
};

Sticky.displayName = 'Sticky';

export default Sticky;
